// API assets can have relative URLs on web; Android serves its UI locally.
export function assetUrl(value) {
  const api = process.env.REACT_APP_API_URL || '/api';
  if (!value || !/^https:\/\//.test(api)) return value;
  if (value.startsWith('/api/')) return `${new URL(api).origin}${value}`;
  if (value.startsWith('/static/')) return `${api.replace(/\/$/, '')}${value}`;
  return value;
}
